<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <!-- Body -->
    <v-layout class="mb-12">
      <v-flex class="" style="position: relative">
        <!-- Header Desktop -->
        <v-layout
          v-if="$vuetify.breakpoint.smAndUp"
          class="justify-center mx-n12 mt-n4 bg-img pa-12"
        >
          <v-flex class="text-center">
            <v-layout>
              <v-flex>
                <v-layout class="justify-center">
                  <v-flex shrink>
                    <v-img
                      height="70px"
                      width="70px"
                      :src="
                        profile && profile.mem_info && profile.mem_info.avatar
                          ? url +
                            imgPath +
                            'images_profile/' +
                            profile.mem_info.avatar
                          : require('../../assets/user_profile.png')
                      "
                      style="border-radius: 100%"
                    ></v-img>
                  </v-flex>
                </v-layout>
                <v-layout mt-4>
                  <v-flex>
                    <div style="color: #fff;font-size: 20px">
                      {{ checkName(profile) }}
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout class="justify-center mt-4">
                  <v-flex class="xs5 flex-center" style="color:#fff">
                    <p>
                      {{ checkBio(profile.mem_info) }}
                    </p>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex>
                    <div style="color: #fff;font-size: 14px">
                      {{ $t("portfolio_profile") }} :
                      {{ portfolio_amount }}
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-6" v-if="profile.mem_info">
                  <v-spacer></v-spacer>
                  <v-flex
                    class="shrink mr-4"
                    v-show="profile.mem_info.instagram"
                  >
                    <a
                      :href="
                        'https://www.instagram.com/' +
                          profile.mem_info.instagram
                      "
                      target="_blank"
                    >
                      <img
                        class="text-center"
                        width="35"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 666@2x.png')
                        "
                        style="cursor: pointer"
                      />
                    </a>
                  </v-flex>
                  <v-flex
                    class="shrink mr-4"
                    v-show="profile.mem_info.facebook"
                  >
                    <a
                      :href="
                        'https://www.facebook.com/' + profile.mem_info.facebook
                      "
                      target="_blank"
                    >
                      <img
                        width="35"
                        :src="
                          require('../../assets/images/detail-portfolio/social/Group 665@2x.png')
                        "
                        style="cursor: pointer"
                      />
                    </a>
                  </v-flex>
                  <v-flex class="shrink" v-show="profile.mem_info.twitter">
                    <a
                      :href="
                        'https://www.twitter.com/' + profile.mem_info.twitter
                      "
                      target="_blank"
                    >
                      <img
                        width="35"
                        :src="
                          require('../../assets/images/detail-portfolio/twitter.png')
                        "
                        style="cursor: pointer"
                      />
                    </a>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout style="color: #fff" class="mt-6">
                  <v-spacer></v-spacer>
                  <v-flex shrink class="px-6">
                    <v-layout>
                      <v-flex shrink class="d-flex justify-center align-center">
                        <img
                          class="mr-2"
                          width="20"
                          :src="
                            require('../../assets/images/detail-portfolio/social/Path 1117@2x.png')
                          "
                          style="cursor: pointer"
                        />
                      </v-flex>
                      <v-flex class="d-flex justify-center align-center">
                        {{
                          profile.mobile_number ? profile.mobile_number : "-"
                        }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider
                    vertical
                    style="border: 0.5px solid #C4C4C4;"
                  ></v-divider>
                  <v-flex shrink class="px-6">
                    <v-layout>
                      <v-flex shrink class="d-flex justify-center align-center">
                        <img
                          class="mr-2"
                          width="20"
                          :src="
                            require('../../assets/images/detail-portfolio/social/Path 1116@2x.png')
                          "
                          style="cursor: pointer"
                        />
                      </v-flex>
                      <v-flex class="d-flex justify-center align-center">
                        {{ profile.email }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider
                    vertical
                    style="border: 0.5px solid #C4C4C4;"
                  ></v-divider>
                  <v-flex shrink class="px-6">
                    <v-layout>
                      <v-flex shrink class="d-flex justify-center align-center">
                        <img
                          class="mr-2"
                          width="20"
                          :src="
                            require('../../assets/images/detail-portfolio/social/Path 1115@2x.png')
                          "
                          style="cursor: pointer"
                        />
                      </v-flex>
                      <v-flex class="d-flex justify-center align-center">
                        {{
                          profile.mem_info && profile.mem_info.location
                            ? profile.mem_info.location
                            : "-"
                        }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Header Mobile -->
        <v-layout v-else class="justify-center mt-n4 bg-img py-12">
          <v-flex class="text-center">
            <v-layout class="justify-center">
              <v-flex shrink>
                <v-img
                  height="70px"
                  width="70px"
                  :src="
                    profile && profile.mem_info && profile.mem_info.avatar
                      ? url +
                        imgPath +
                        'images_profile/' +
                        profile.mem_info.avatar
                      : require('../../assets/user_profile.png')
                  "
                  style="border-radius: 100%"
                ></v-img>
              </v-flex>
            </v-layout>
            <v-layout mt-4>
              <v-flex>
                <div style="color: #fff;font-size: 20px" class="ellipsis-title">
                  {{ checkName(profile) }}
                </div>
              </v-flex>
            </v-layout>

            <v-layout class="justify-center mt-4">
              <v-flex
                class="xs11 flex-center"
                style="color:#fff;font-size:14px"
              >
                <p v-if="$vuetify.breakpoint.smAndUp">
                  {{ bio.length > 150 ? bio.slice(0, 145) + "...." : bio }}
                </p>
                <p v-else>
                  {{ bio.length > 135 ? bio.slice(0, 130) + "...." : bio }}
                </p>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex>
                <div style="color: #fff;font-size: 14px">
                  {{ $t("portfolio_profile") }} :
                  {{ portfolio_amount }}
                </div>
              </v-flex>
            </v-layout>

            <v-layout class="mt-6" v-if="profile.mem_info">
              <v-spacer></v-spacer>
              <v-flex class="shrink mr-4" v-show="profile.mem_info.instagram">
                <a
                  :href="
                    'https://www.instagram.com/' + profile.mem_info.instagram
                  "
                  target="_blank"
                >
                  <img
                    class="text-center"
                    width="35"
                    :src="
                      require('../../assets/images/detail-portfolio/social/Group 666@2x.png')
                    "
                    style="cursor: pointer"
                  />
                </a>
              </v-flex>
              <v-flex class="shrink mr-4" v-show="profile.mem_info.facebook">
                <a
                  :href="
                    'https://www.facebook.com/' + profile.mem_info.facebook
                  "
                  target="_blank"
                >
                  <img
                    width="35"
                    :src="
                      require('../../assets/images/detail-portfolio/social/Group 665@2x.png')
                    "
                    style="cursor: pointer"
                  />
                </a>
              </v-flex>
              <v-flex class="shrink" v-show="profile.mem_info.twitter">
                <a
                  :href="'https://www.twitter.com/' + profile.mem_info.twitter"
                  target="_blank"
                >
                  <img
                    width="35"
                    :src="
                      require('../../assets/images/detail-portfolio/twitter.png')
                    "
                    style="cursor: pointer"
                  />
                </a>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout style="color: #fff" class="mt-6 column">
              <v-flex shrink class="px-6 mt-3">
                <v-layout>
                  <v-flex shrink class="d-flex justify-center align-center">
                    <img
                      class="mr-2"
                      width="20"
                      :src="
                        require('../../assets/images/detail-portfolio/social/Path 1117@2x.png')
                      "
                      style="cursor: pointer"
                    />
                  </v-flex>
                  <v-flex class="d-flex justify-start align-center">
                    {{ profile.mobile_number ? profile.mobile_number : "-" }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex shrink class="px-6 mt-3">
                <v-layout>
                  <v-flex shrink class="d-flex justify-center align-center">
                    <img
                      class="mr-2"
                      width="20"
                      :src="
                        require('../../assets/images/detail-portfolio/social/Path 1116@2x.png')
                      "
                      style="cursor: pointer"
                    />
                  </v-flex>
                  <v-flex class="d-flex justify-start align-center">
                    {{ profile.email }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex shrink class="px-6 mt-3">
                <v-layout>
                  <v-flex shrink class="d-flex justify-center align-center">
                    <img
                      class="mr-2"
                      width="20"
                      :src="
                        require('../../assets/images/detail-portfolio/social/Path 1115@2x.png')
                      "
                      style="cursor: pointer"
                    />
                  </v-flex>
                  <v-flex class="d-flex text-left align-center">
                    {{
                      profile.mem_info && profile.mem_info.location
                        ? profile.mem_info.location
                        : "-"
                    }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- SlideGroup -->
        <v-layout class="justify-center px-2 mt-10">
          <v-flex xs12>
            <v-sheet
              :style="{ 'background-color': '#F8F8F8' }"
              class="mx-auto"
              max-width="100%"
            >
              <v-slide-group
                v-model="model"
                show-arrows
                center-active
                class="slide-group"
              >
                <v-slide-item
                  v-for="(category, i) in categorys"
                  :key="i"
                  v-slot:default="{ toggle }"
                >
                  <v-btn
                    v-if="category.portfolio_total !== 0"
                    @click="toggle"
                    class="mx-1 my-2"
                    :style="
                      selected_category_id === category.id
                        ? {
                            'background-color': checkBtnColor(category.id),
                            color: '#FFFFFF',
                            height: '40px',
                          }
                        : {
                            color: '#FFFFFF',
                            'background-color': '#9C9C9C',
                          }
                    "
                    height="40"
                    @click.native="onclickCategory(category.id)"
                  >
                    <v-img
                      lazy-src=""
                      :width="category.id == 0 ? '20' : '35'"
                      :src="checkIcon(category.name_en)"
                    ></v-img>
                    <span class="ml-4">{{
                      switchLanguage === "th"
                        ? category.name_th
                        : category.name_en
                    }}</span>
                    <span class="ml-3" style="color: #fff">
                      {{ category.portfolio_total }}
                    </span>
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </v-flex>
        </v-layout>

        <!-- All Portfolio -->
        <v-layout class="justify-center mb-8">
          <v-flex xs12>
            <!-- Sub Slide Group -->
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <v-layout v-show="categoryID != 0" class="justify-center px-2">
                <v-flex xs12>
                  <v-layout wrap class="mt-3" style="background-color: #F8F8F8">
                    <v-flex
                      class="shrink on-hover-cate mr-3 mb-2 d-flex justify-center align-center"
                      @click="onClickSubCate(0)"
                      :class="subcategory_id === 0 ? 'active-category' : ''"
                    >
                      <v-btn
                        v-if="subcategory_id === 0"
                        width="100%"
                        height="100%"
                        outlined
                        color="#FD5246"
                      >
                        <span>{{ $t("all") }}</span>
                      </v-btn>
                      <div v-if="subcategory_id !== 0">All</div>
                      <!-- <v-divider
                        class="ml-2"
                        v-if="subcategory_id !== 0"
                        vertical
                      ></v-divider> -->
                    </v-flex>
                    <!-- <div
                      class="d-flex"
                      v-for="(subCate, i) in subCategoryLists"
                      :key="i"
                    > -->
                    <v-flex
                      v-for="(subCate, i) in subCategoryLists"
                      :key="i"
                      shrink
                      class="text-center on-hover-cate d-flex align-center mr-3 mb-2"
                      @click="
                        subCate.subcategory
                          ? onClickSubCate(subCate.subcategory.id)
                          : ''
                      "
                    >
                      <div
                        class="d-flex"
                        v-if="subCate.subcategory && subCate.total > 0"
                      >
                        <v-btn
                          v-if="subcategory_id === subCate.subcategory.id"
                          width="100%"
                          height="100%"
                          outlined
                          large
                          color="#FD5246"
                        >
                          <span>
                            {{
                              switchLanguage === "th"
                                ? subCate.subcategory.name_th
                                : subCate.subcategory.name_en
                            }}
                            ({{ subCate.total }})
                          </span>
                        </v-btn>
                        <span v-else>
                          {{
                            switchLanguage === "th"
                              ? subCate.subcategory.name_th
                              : subCate.subcategory.name_en
                          }}
                          ({{ subCate.total }})
                        </span>
                        <!-- <v-divider
                          class="ml-2"
                          v-if="subcategory_id !== subCate.subcategory.id"
                          vertical
                        ></v-divider> -->
                      </div>
                    </v-flex>
                    <!-- </div> -->
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              <!-- Sub Slide Group Mobile -->
              <v-layout class="px-3" v-if="selected_category_id != 0">
                <v-flex v-if="subCateLists.length > 0">
                  <v-autocomplete
                    hide-details
                    placeholder="หมวดหมู่ย่อย"
                    color="#FD5246"
                    outlined
                    dense
                    flat
                    menu-props="offset-y"
                    :items="subCateLists"
                    item-value="id"
                    :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
                    @change="onClickSubCate"
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ $i18n.locale === "th" ? item.name_th : item.name_en }}
                      ({{ item.total }})
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </div>

            <v-layout
              class="px-12 mt-12"
              v-if="portfolios.data === []"
              style="padding-bottom: 29rem"
            >
              <v-flex class="text-center">
                <span style="color: #5d5d5d">{{ $t("status-not-fount") }}</span>
              </v-flex>
            </v-layout>

            <v-container fluid mt-8>
              <v-card flat color="#F8F8F8" min-height="300px">
                <v-row>
                  <v-col
                    v-for="(portfolioArticle, index) in portfolios.data"
                    :key="index"
                    :cols="
                      $vuetify.breakpoint.lgAndUp
                        ? 2
                        : '' || $vuetify.breakpoint.md
                        ? 3
                        : '' || $vuetify.breakpoint.sm
                        ? 6
                        : '' || $vuetify.breakpoint.xs
                        ? 12
                        : ''
                    "
                    @click="viewPortDetail(portfolioArticle)"
                  >
                    <card-content
                      font-lg="14"
                      font-md="14"
                      font-sm="14"
                      :hoverTitle="portfolioArticle.project_title"
                      width="100"
                      height="100%"
                      :image-cover="portfolioArticle.cover_img_path"
                      :title="portfolioArticle.project_title"
                      :by="portfolioArticle.profile"
                      :image-profile="
                        portfolioArticle.profile
                          ? checkImage(portfolioArticle.profile.mem_info)
                          : ''
                      "
                    ></card-content>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex class="paginate">
            <v-pagination
              color="#FD5246"
              light
              v-model="paginate.current_page"
              :length="paginate.last_page"
              :total-visible="7"
              @input="getPortfolioByMemberIdCategoryId"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </v-content>
</template>

<script>
import SlideGroup from "../../components/slide_group/SlideGroup";
import { domain, imgPath } from "../../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";
import axios from "axios";
import CardContent from "../../components/card_content/CardContent";

export default {
  name: "AllPortfolioByDesign",
  components: {
    SlideGroup,
    CardContent,
    Loading,
  },
  data: () => ({
    bio: "",
    selected_category_id: 0,
    model: null,
    imgPath: imgPath,
    url: domain,
    domain_name: "",
    profile: [],
    isLoading: false,
    isLoadingCate: false,
    isLoadingProfile: false,
    isLoadingPortfolio: true,
    portfolio_amount: 0,
    categorys: [
      {
        id: 0,
        name_th: "รวม",
        name_en: "All",
        icon: "subject",
        portfolio_total: "",
      },
    ],
    subCateLists: [],
  }),
  async created() {
    // this.profile_id = this.$route.query.profile_id;
    this.domain_name = this.$route.params.domain_slug;
    this.isLoading = true;
    await Promise.all([
      this.getPortfolioByMemberIdCategoryId(1),
      this.getMemberProfile(),
      this.getCategoryByDesign(),
      this.clearPaginate(1),
    ]);
    this.isLoading = false;
  },
  watch: {
    subCategoryLists: function(val) {
      this.subCateLists = [];
      for (var key of Object.keys(this.subCategoryLists)) {
        if (this.subCategoryLists[key].subcategory) {
          this.subCateLists.push({
            category_id: this.subCategoryLists[key].subcategory.category_id,
            id: this.subCategoryLists[key].subcategory.id,
            name_en: this.subCategoryLists[key].subcategory.name_en,
            name_th: this.subCategoryLists[key].subcategory.name_th,
            total: this.subCategoryLists[key].total,
          });
        }
      }
    },
  },
  computed: {
    ...mapState({
      portfolios: (state) => {
        return state.portfolio.portfolio_design.portfolios;
      },
      subCategoryLists: (state) => {
        return state.portfolio.portfolio_design.subCategoryLists;
      },
      categoryID: (state) => {
        return state.portfolio.portfolio_design.categoryID;
      },
      subcategory_id: (state) => {
        return state.portfolio.portfolio_design.subcategory_id;
      },
      paginate: (state) => {
        return state.portfolio.portfolio_design.paginate;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  methods: {
    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
    clearPaginate(page) {
      return this.$store.dispatch("portfolio/clearPaginate", page);
    },
    getMemberProfile() {
      return this.$store
        .dispatch("profile/onGetProfile", this.domain_name)
        .then((res) => {
          this.profile = res;
        });
    },
    getPortfolioByMemberIdCategoryId(page) {
      this.isLoading = true;
      return this.$store
        .dispatch("portfolio/getPortfolioDesign", {
          page: page,
          profile_id: this.domain_name,
          category_id: this.categoryID,
          subcategory_id: 0,
        })
        .then((res) => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    onclickCategory(id) {
      this.selected_category_id = id;
      this.isLoading = true;
      let data = {
        page: this.paginate.current_page,
        profile_id: this.domain_name,
        category_id: id,
        subcategory_id: 0,
      };
      this.$store.dispatch("portfolio/getPortfolioDesign", data).then((res) => {
        this.isLoading = false;
      });
    },
    onclickSubCategoryAll() {
      this.isLoading = true;
      let data = {
        page: 1,
        id: this.categoryID,
      };
      this.$store
        .dispatch("portfolio/getPortfolioByIdCategory", data)
        .then(() => {
          this.isLoading = false;
        });
    },
    onClickSubCate(id) {
      this.isLoading = true;
      let data = {
        page: this.paginate.current_page,
        profile_id: this.domain_name,
        category_id: this.categoryID,
        subcategory_id: id,
      };
      this.$store.dispatch("portfolio/getPortfolioDesign", data).then((res) => {
        this.isLoading = false;
      });
    },
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
         path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    getCategoryByDesign() {
      return axios({
        url: `${domain}api/get-category-design?profile_id=${this.domain_name}`,
        method: "GET",
      }).then((res) => {
        this.portfolio_amount = res.data.count_port_all;
        this.categorys[0].portfolio_total = res.data.count_port_all;
        res.data.categories_list.forEach((data) => {
          this.categorys.push({
            id: data.id,
            name_th: data.name_th,
            name_en: data.name_en,
            icon: data.icon,
            portfolio_total: data.portfolio_total,
          });
        });
      });
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 50) {
          return val.name_th.length > 55
            ? val.name_th.slice(0, 50) + " . . . . "
            : val.name_th;
        } else {
          return (
            val.name_th +
            " " +
            (val.last_th.length > 55
              ? val.last_th.slice(0, 50) + " . . . . "
              : val.last_th)
          );
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 50) {
          return val.name_en.length > 55
            ? val.name_en.slice(0, 50) + " . . . . "
            : val.name_en;
        } else {
          return (
            val.name_en +
            " " +
            (val.last_en.length > 55
              ? val.last_en.slice(0, 50) + " . . . . "
              : val.last_en)
          );
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
    checkBtnColor(cateId) {
      switch (cateId) {
        case "0":
          return "#ef3e2e";
        case "10":
          return "#74bf92";
        case "11":
          return "#ac9277";
        case "12":
          return "#c98074";
        case "1":
          return "#957722";
        case "9":
          return "#e19705";
        case "4":
          return "#4cc2d2";
        case "13":
          return "#e47645";
        case "115":
          return "#8a233d";
        case "5":
          return "#cd4646";
        case "7":
          return "#92b4cb";
        case "8":
          return "#9f939a";
        case "2":
          return "#733c90";
        case "3":
          return "#684c41";
        case "6":
          return "#3b5fa6";
        case "14":
          return "#28645e";
        default:
          return "#ef3e2e";
      }
    },
    checkImage(val) {
      if (val) {
        if (val.avatar) {
          return val.avatar;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    checkBio(member) {
      if (member) {
        return member.bio ? member.bio : "";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
.bg-img {
  height: auto;
  background-image: url("../../assets/images/all-portfolio/MaskGroup.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
.on-hover-cate:hover {
  color: #fd5246;
  cursor: pointer;
}
.hover-link span:hover {
  color: #fd5246;
  cursor: pointer;
}

.hover-link {
  color: #ffffff;
  cursor: pointer;
}

.paginate {
  .v-pagination__item {
    box-shadow: unset;
  }
}

.paginate {
  .v-pagination__navigation {
    box-shadow: unset;
  }
}

.ellipsis-title {
  padding: 0 1rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
